import { render, staticRenderFns } from "./ShopOrderList.vue?vue&type=template&id=8d93d188&"
import script from "./ShopOrderList.vue?vue&type=script&lang=js&"
export * from "./ShopOrderList.vue?vue&type=script&lang=js&"
import style0 from "./ShopOrderList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports